import { getDatasWithOption } from '../../utils/service';
import { BREAKPOINTS } from '../../model/model';
import { isChrome, isDefined, isObject, not, isNotDefined, each, truthy, falsy, parseInt10, isMobileResolution, getResolution } from '../../utils/util';

class BeginnerRecommend {
    constructor(options) {
    const _ = this;

    if (!options) return;

    if (!options) return;
    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      classId: 0,
      level: 1,
      isLogin: false,
      global: window
    }, options);

    _.global = (_.option.global) ? _.option.global : window;

    }

    init() {
      const _ = this,
            _wrap = _.option.wrap.recommendWrap;
      console.log('# BeginnerRecommend init !! ');

      getDatasWithOption([{
          type: 'GET',
          url: _.option.apiDomain +'/conti/getContent?service=lineage&alias=beginner-recommend&lang=ko-KR',
          dataType: 'json',
          contentType: 'application/json',
          Accept: 'application/json'
      }], (data) => {
          console.log('# BeginnerRecommend.js data : ', JSON.parse(data.jsonData) );
          if(data.jsonData.length <= 0) {
              _.setNoData();
          } else {
              _.setData(JSON.parse(data.jsonData));
              _.setVideoData(JSON.parse(data.jsonData));
          }
      }, (data) => {
          console.log('데이터를 불러올 수 없습니다. 잠시 후, 다시 시도해주세요.');
      });

    }
    setNoData() {
        $(this.option.wrap.recommendWrap).empty().append(`<div class="nodata"> - </div>`);
   }
   setData(data) {
        let _data = data.items;
        let _tmpl = `<section class="section-recommend">
            <header><h2>추천 콘텐츠</h2></header>
            <article>
                <p class="copy">플레이에 도움을 줄 유용한 콘텐츠들을<br> 놓치지 말고 확인하세요.</p>
                <div class="article-recommend">	
            ${_data.map((item, index) => {
                return `<div class="recommend-card">
                  <a href="${item.url}" class="${item.target}">
                    <dl>
                      <dd class="recommend-card__thumb"><img src="${item.img}"></dd>
                      <dt class="recommend-card__subject">${item.subject}</dt>
                      <dd class="recommend-card__desc">${item.desc}</dd>
                    </dl>
                  </a>
                </div>`;
            }).join('')}
              </div>
            </article>
            </section>`;
       $(this.option.wrap.recommendWrap).empty().append(_tmpl);
       this.setSlick();
   }
    setVideoData(data) {
        let _data = data.videoItems;
        let _tmpl = `<section class="section-video">
            <header><h2>영상 가이드</h2></header>
            <article>
                <ul class="article-video">	
            ${_data.map((item, index) => {
            return `<li class="video-card">
                  <a class="btn-video" href="${item.url}" target="_blank">${item.subject}</a>
                </li>`;
        }).join('')}
              </ul>
            </article>
            </section>`;
        $(this.option.wrap.videoWrap).empty().append(_tmpl);
    }

  setSlick(){
      const _ = this,
          _wrap = _.option.wrap.recommendWrap;

    let recommendSlider = $('.article-recommend', _wrap);
      recommendSlider.slick({
        dots: true,
        infinite: true,
        arrows: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
            {
                breakpoint: 3840,
                settings: "unslick"
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    });
    $(window).resize(function() {
        recommendSlider.slick('resize');
    });


  } // setSlick()

}

export default BeginnerRecommend;


// WEBPACK FOOTER //
// ./_src/js/service/beginner/BeginnerRecommend.js